import React from 'react';
import Topbar from './Topbar';

interface AppLayoutProps {
  children: React.ReactNode;
  transparentTopbar?: boolean;
}

export default function AppLayout({ children, transparentTopbar = false }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <Topbar transparent={transparentTopbar} />
      <main>{children}</main>
    </div>
  );
}